export default (editor) => {
  const initialKey = editor.value.focusBlock.key;
  editor.moveFocusForward(1);
  const newKey = editor.value.focusBlock.key;
  editor.moveFocusBackward(1);
  return initialKey !== newKey;
};
